/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Collections_Table_VarianceInputs */

const id_collections_table_variance = /** @type {(inputs: Collections_Table_VarianceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Variansi`)
};

const ms_collections_table_variance = /** @type {(inputs: Collections_Table_VarianceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Varians`)
};

const da_collections_table_variance = /** @type {(inputs: Collections_Table_VarianceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Varians`)
};

const de_collections_table_variance = /** @type {(inputs: Collections_Table_VarianceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abweichung`)
};

const en_us2_collections_table_variance = /** @type {(inputs: Collections_Table_VarianceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Variance`)
};

const es_es2_collections_table_variance = /** @type {(inputs: Collections_Table_VarianceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Varianza`)
};

const es_mx2_collections_table_variance = /** @type {(inputs: Collections_Table_VarianceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Variación`)
};

const fil_collections_table_variance = /** @type {(inputs: Collections_Table_VarianceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pagkakaiba`)
};

const fr_collections_table_variance = /** @type {(inputs: Collections_Table_VarianceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Variation`)
};

const it_collections_table_variance = /** @type {(inputs: Collections_Table_VarianceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Variazione`)
};

const hu_collections_table_variance = /** @type {(inputs: Collections_Table_VarianceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eltérés`)
};

const nl_collections_table_variance = /** @type {(inputs: Collections_Table_VarianceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verschil`)
};

const no_collections_table_variance = /** @type {(inputs: Collections_Table_VarianceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Avvik`)
};

const pl_collections_table_variance = /** @type {(inputs: Collections_Table_VarianceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zmiana`)
};

const pt_br2_collections_table_variance = /** @type {(inputs: Collections_Table_VarianceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Variância`)
};

const pt_collections_table_variance = /** @type {(inputs: Collections_Table_VarianceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Variação`)
};

const ro_collections_table_variance = /** @type {(inputs: Collections_Table_VarianceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Variație`)
};

const fi_collections_table_variance = /** @type {(inputs: Collections_Table_VarianceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Muutos`)
};

const sv_collections_table_variance = /** @type {(inputs: Collections_Table_VarianceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Förändring`)
};

const vi_collections_table_variance = /** @type {(inputs: Collections_Table_VarianceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chênh lệch`)
};

const tr_collections_table_variance = /** @type {(inputs: Collections_Table_VarianceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Değişim`)
};

const cs_collections_table_variance = /** @type {(inputs: Collections_Table_VarianceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Odchylka`)
};

const bg_collections_table_variance = /** @type {(inputs: Collections_Table_VarianceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Разлика`)
};

const ru_collections_table_variance = /** @type {(inputs: Collections_Table_VarianceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Изменение`)
};

const uk_collections_table_variance = /** @type {(inputs: Collections_Table_VarianceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Відхилення`)
};

const ar_collections_table_variance = /** @type {(inputs: Collections_Table_VarianceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الفرق`)
};

const hi_collections_table_variance = /** @type {(inputs: Collections_Table_VarianceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अंतर`)
};

const th_collections_table_variance = /** @type {(inputs: Collections_Table_VarianceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ความแปรปรวน`)
};

const ja_collections_table_variance = /** @type {(inputs: Collections_Table_VarianceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`変動`)
};

const zh_cn2_collections_table_variance = /** @type {(inputs: Collections_Table_VarianceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`变动`)
};

const zh_hant1_collections_table_variance = /** @type {(inputs: Collections_Table_VarianceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`變動`)
};

const ko_collections_table_variance = /** @type {(inputs: Collections_Table_VarianceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`변동`)
};

/**
* | output |
* | --- |
* | "Variance" |
*
* @param {Collections_Table_VarianceInputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const collections_table_variance = /** @type {((inputs?: Collections_Table_VarianceInputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Collections_Table_VarianceInputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_collections_table_variance(inputs)
	if (locale === "ms") return ms_collections_table_variance(inputs)
	if (locale === "da") return da_collections_table_variance(inputs)
	if (locale === "de") return de_collections_table_variance(inputs)
	if (locale === "en-US") return en_us2_collections_table_variance(inputs)
	if (locale === "es-ES") return es_es2_collections_table_variance(inputs)
	if (locale === "es-MX") return es_mx2_collections_table_variance(inputs)
	if (locale === "fil") return fil_collections_table_variance(inputs)
	if (locale === "fr") return fr_collections_table_variance(inputs)
	if (locale === "it") return it_collections_table_variance(inputs)
	if (locale === "hu") return hu_collections_table_variance(inputs)
	if (locale === "nl") return nl_collections_table_variance(inputs)
	if (locale === "no") return no_collections_table_variance(inputs)
	if (locale === "pl") return pl_collections_table_variance(inputs)
	if (locale === "pt-BR") return pt_br2_collections_table_variance(inputs)
	if (locale === "pt") return pt_collections_table_variance(inputs)
	if (locale === "ro") return ro_collections_table_variance(inputs)
	if (locale === "fi") return fi_collections_table_variance(inputs)
	if (locale === "sv") return sv_collections_table_variance(inputs)
	if (locale === "vi") return vi_collections_table_variance(inputs)
	if (locale === "tr") return tr_collections_table_variance(inputs)
	if (locale === "cs") return cs_collections_table_variance(inputs)
	if (locale === "bg") return bg_collections_table_variance(inputs)
	if (locale === "ru") return ru_collections_table_variance(inputs)
	if (locale === "uk") return uk_collections_table_variance(inputs)
	if (locale === "ar") return ar_collections_table_variance(inputs)
	if (locale === "hi") return hi_collections_table_variance(inputs)
	if (locale === "th") return th_collections_table_variance(inputs)
	if (locale === "ja") return ja_collections_table_variance(inputs)
	if (locale === "zh-CN") return zh_cn2_collections_table_variance(inputs)
	if (locale === "zh-Hant") return zh_hant1_collections_table_variance(inputs)
	return ko_collections_table_variance(inputs)
});
export { collections_table_variance as "collections.table.variance" }